module.exports = __webpack_public_path__ + "static/media/woocommerce-logo.2a0e4536.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/woocommerce-logo.svg
// module id = 618
// module chunks = 0